// extracted by mini-css-extract-plugin
export default {"section":"As-z","inSectionButton":"Bs-z","addressCard":"Cs-z","disabled":"Ds-z","cautionBox":"Es-z","failureBox":"Fs-z","fade-out":"Gs-z","successBox":"Hs-z"};